import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

// check allowed permissions
export const getAllowedPermission = (allowed = [], operations = []) => {
	if (!allowed) {
		return false;
	}

	if (!Array.isArray(allowed)) {
		allowed = [allowed];
	}

	for (const a of allowed) {
		if (operations?.includes(a)) {
			return true;
		}
	}

	return false;
};

/**
 * Check if the user has permission
 * @param allowed
 * @returns {*}
 *
 * @example
 * const isAllowed = useAllowedPermissions('permission');
 */
export const useAllowedPermission = (allowed) => {
	const user = useSelector((state) => state.user);

	return useMemo(() => {
		return getAllowedPermission(allowed, user?.operations);
	}, [allowed, user]);
};

/**
 * Check if the user has permission to see component
 * @param allowed
 * @param children
 * @returns {*}
 * @constructor
 *
 * @example
 * <Permission allowed="permission">
 *     <Component />
 * </Permission>
 */
export const Permission = ({ allowed, children }) => {
	const isAllowed = useAllowedPermission(allowed);

	if (isAllowed) {
		return children;
	}

	return null;
};

/**
 * HOC for permission check
 * @param allowed
 * @returns {function(*): function(*): *}
 *
 * @example
 * export default withPermissions('permission')(Component);
 */
export const withPermission = (allowed) => (Component) => {
	return (props) => {
		return (
			<Permission allowed={allowed}>
				<Component {...props} />
			</Permission>
		);
	};
};
